import { Box, Divider, Text } from '@doist/marketist'

import { Interpolate } from 'components'
import { useTranslation } from 'next-i18next'

import css from './CustomerStories.module.css'

function Percentages() {
    const { t } = useTranslation('customers')

    return (
        <Box className={css.grid}>
            {[...Array(4)].map((_, i) => (
                <Box key={`item${i}`} className={css.gridItem}>
                    <Box className={css.copy}>
                        <Text className={css.percent} size="major-base">
                            <Interpolate
                                t={t}
                                i18nKey={`percentages.item${i + 1}.percent`}
                                mapping={{
                                    0: (
                                        <Text
                                            tag="span"
                                            size="minor-lg"
                                            className={css.percentSymbol}
                                        />
                                    ),
                                }}
                            />
                        </Text>

                        <Text size="body-sm">{t(`percentages.item${i + 1}.text`)}</Text>
                    </Box>
                    {/* Dividers should only be between boxes */}
                    {i !== 3 ? (
                        <div className={css.verticalDivider}>
                            <Divider direction="vertical" />
                        </div>
                    ) : null}
                </Box>
            ))}
        </Box>
    )
}

export { Percentages }
